import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { SentryErrorBoundary } from '@flote/sentry-browser';
import { deliveryTsr, deliveryQueryClient } from './api';
import { DeliveryAuthProvider } from './auth';
import { ProtectedRoute, AdminLayout, ErrorFallback } from './components';
import {
  LoginPage,
  DashboardPage,
  TasksPage,
  TaskDetailPage,
  DeliveriesPage,
  DriversPage,
  DriverDetailPage,
  TeamsPage,
  TeamDetailPage,
  HubsPage,
  RecipientsPage,
  DestinationsPage,
  VehiclesPage,
  WebhooksPage,
  OptimizePage,
  PartitionsPage,
  PartitionDetailPage,
} from './pages';

export function App() {
  return (
    <QueryClientProvider client={deliveryQueryClient}>
      <deliveryTsr.ReactQueryProvider>
        <BrowserRouter>
          <SentryErrorBoundary fallback={ErrorFallback}>
            <DeliveryAuthProvider>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<ProtectedRoute />}>
                  <Route element={<AdminLayout />}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/tasks" element={<TasksPage />} />
                    <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
                    <Route path="/deliveries" element={<DeliveriesPage />} />
                    <Route path="/drivers" element={<DriversPage />} />
                    <Route path="/drivers/:driverId" element={<DriverDetailPage />} />
                    <Route path="/teams" element={<TeamsPage />} />
                    <Route path="/teams/:teamId" element={<TeamDetailPage />} />
                    <Route path="/hubs" element={<HubsPage />} />
                    <Route path="/recipients" element={<RecipientsPage />} />
                    <Route path="/destinations" element={<DestinationsPage />} />
                    <Route path="/vehicles" element={<VehiclesPage />} />
                    <Route path="/webhooks" element={<WebhooksPage />} />
                    <Route path="/optimize" element={<OptimizePage />} />
                    <Route path="/partitions" element={<PartitionsPage />} />
                    <Route path="/partitions/:partitionId" element={<PartitionDetailPage />} />
                    <Route path="/settings" element={<div className="p-4">Settings - Coming Soon</div>} />
                  </Route>
                </Route>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
              <Toaster position="top-center" richColors />
            </DeliveryAuthProvider>
          </SentryErrorBoundary>
        </BrowserRouter>
      </deliveryTsr.ReactQueryProvider>
    </QueryClientProvider>
  );
}
